import { useMemo, useState } from "react";
import FilmCard from "@/components/base/FilmCard";
import { getAllFilms } from "@/lib/films";

const tabs = [
  { key: "all", label: "全部" },
  { key: "movie", label: "电影" },
  { key: "tv", label: "电视剧" },
  { key: "web", label: "网络剧" },
];

export default function FeaturedSection() {
  const [tab, setTab] = useState("all");
  const allFilms = getAllFilms();

  const list = useMemo(() => {
    const filtered = tab === "all" ? allFilms : allFilms.filter((film) => film.category === tab);
    return [...filtered].sort((a, b) => b.rating - a.rating).slice(0, 8);
  }, [tab, allFilms]);

  return (
    <section className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
            <i className="ri-award-line text-sm" />
            编辑精选
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">高口碑影视推荐</h2>
          <p className="mt-2 text-sm text-foreground-600">按评分精选，剧情与角色都经得起反复品读。</p>
        </div>
        <div className="flex flex-wrap gap-1 rounded-full bg-background-100 p-1">
          {tabs.map((item) => (
            <button
              key={item.key}
              type="button"
              onClick={() => setTab(item.key)}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
                tab === item.key ? "bg-primary-500 text-background-50" : "text-foreground-700 hover:text-foreground-950"
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
        {list.map((film) => (
          <FilmCard key={film.id} film={film} />
        ))}
      </div>
    </section>
  );
}